var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPbfPendingDeregistration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7,
    rx: 7.5,
    ry: 7,
    fill: "#FF2800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.949 11h-2.85V2.662h2.85c2.587 0 4.275 1.813 4.275 4.176C11.224 9.213 9.536 11 6.949 11zm0-.925c2.025 0 3.2-1.45 3.2-3.237 0-1.8-1.138-3.25-3.2-3.25H5.136v6.487H6.95z",
    fill: "#fff"
  })));
}
export default SvgPbfPendingDeregistration;